<template>
    <div id="partiOra" class="py-2" v-if="list.length>0">
        <h1>{{title}}</h1>
        <div class="pb-3" v-if="resultMessage">
                <span class="text-primary">{{resultMessage}}</span>
        </div>
        <h5 class="text-primary text-uppercase">{{subtitle}}</h5>

        <div>
            <carousel :per-page=4 navigation-enabled :pagination-enabled=false navigation-next-label="<div></div>" navigation-prev-label="<div></div>">
                <slide v-for="(item, index) in list" :key="index">
                    <VerticalItemTour :value="item" @select="onOpenDetail"/>
                </slide>
            </carousel>
        </div>
        <ModalTourDetail v-if="tourSelected" :is-home-page="true" :value="tourSelected" ref="modalTourDetail" @select="onSelect" :is-camere-requested="true"/>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import VerticalItemTour from '../../common/tours/VerticalItemTour'
import {toDateFromServer} from '../../../../utils/formatter'
import ModalTourDetail from '../tour-accompagnati/modals/ModalTourDetail'
import TourAccompagnatiSearcher from '../../../searcher/TourAccompagnatiSearcher'

export default {
  name: 'ProssimiTour',
  mixins: [TourAccompagnatiSearcher],
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  components: {ModalTourDetail, VerticalItemTour},
  data () {
    return {
      tourSelected: null
    }
  },
  computed: {
    list () {
      const list = this.getTourList().filter((tour) => {
        return !tour.mini && tour.config && !tour.config.isDisabilitato
      }).filter((tour, index) => {
        return index < 8
      })
      return list.sort((a, b) => {
        if (a.detailResponse.detail && a.detailResponse.detail.departureDate && b.detailResponse.detail && b.detailResponse.detail.departureDate) {
          const dateA = toDateFromServer(a.detailResponse.detail.departureDate.date)
          const dateB = toDateFromServer(b.detailResponse.detail.departureDate.date)
          return dateA.getTime() > dateB.getTime()
        }
        return 0
      })
    }
  },
  methods: {
    ...mapGetters(['getTourList']),
    ...mapActions(['addSearch']),
    onOpenDetail (payout) {
      const {tour, date} = payout
      this.tourSelected = null
      this.$nextTick(() => {
        this.tourSelected = tour
        this.$nextTick(() => {
          this.$refs.modalTourDetail.open(date)
        })
      })
    },
    onSelect (tour) {
      this.searchAllTourAccompagnati(tour)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/home/ProssimiTour.vue